import { type IAppState } from 'services/app-state-provider';
import { ChatsEntitiesActions } from 'store/entities/chats/actions';
import { getThreadExists, getHistoryThreadExists } from 'store/entities/chats/selectors';

import { type IThreadUntaggedPushEvent } from '../interfaces';

/**
 * Handles thread untagged push event.
 * 1. Removes the tag from the thread.
 * @param {IThreadUntaggedPushEvent} payload Push event payload.
 * @param {Store<IWithChatsEntityState>} store Redux store.
 */
export function handleThreadUntagged(payload: IThreadUntaggedPushEvent, store: IAppState): void {
  const state = store.getState();
  const threadExist = getThreadExists(state, payload.thread_id) || getHistoryThreadExists(state, payload.thread_id);

  if (threadExist) {
    /**
     * 1. Removes the tag from the thread.
     * @todo: This should be handled by a single action without using
     *        actions for saving tag request.
     */
    store.dispatch(
      ChatsEntitiesActions.removeTag({
        threadId: payload.thread_id,
        tag: payload.tag,
      })
    );
    store.dispatch(ChatsEntitiesActions.unsetTagSuccess({ threadId: payload.thread_id, tag: payload.tag }));
  }
}
